export enum AmazonLexLanguage {
  "English (US)" = "en-US",
  "English (UK)" = "en-GB",
  "English (Australia)" = "en-AU",
  "English (Canada)" = "en-CA",
  "English (India)" = "en-IN",

  "German (Germany)" = "de-DE",
  "Spanish (Spain)" = "es-ES",
  "Spanish (Mexico)" = "es-MX",
  "French (Canada)" = "fr-CA",
  "French (France)" = "fr-FR",

  "Italian (Italy)" = "it-IT",
  "Japanese (Japan)" = "ja-JP",
  "Korean (South Korea)" = "ko-KR",
  "Portuguese (Brazil)" = "pt-BR",
  "Chinese (Simplified)" = "zh-CN",
}
